"use client";

import React, { useState } from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../../styles/entry-req.css';

const CourseEntryReq = ({ entryReq }) => {
    const [tabIndex, setTabIndex] = useState(0);
    if (!entryReq) return null;      
    return (
        <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                <TabList>
                    {Object.keys(entryReq).filter(key => key !== "link").map((key, index) => (
                        <Tab key={index}>{key}</Tab>
                    ))}
                </TabList>
                {Object.entries(entryReq).filter(([key, item]) => key !== "link").map(([key, item], index) => (
                    <TabPanel key={index}>
                        <div dangerouslySetInnerHTML={{ __html: item }} />
                    </TabPanel>
                ))}
            </Tabs>
            <div style={{width: "100%", textAlign: "center", marginTop: "12px"}}>
                <a className="btn btn-primary" href={entryReq.link}>More Details</a>
            </div>
        </div>
    );
};

export default CourseEntryReq;

// import React from 'react';

// const CourseEntryReq = ({ entryReq }) => {
//   if (!entryReq) return null;

//   return (
//     <div className="entry-requirements">
//       <div className="cert-req">{entryReq.cert}</div>
//       <div className="level-req">{entryReq.level}</div>
//       {entryReq.link && (
//         <div className="req-link">
//           <a href={entryReq.link}>View Full Requirements</a>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CourseEntryReq;